import React from "react";
import { RightPanel } from "../../RightPanel";
import { useDispatchWrapper } from "../../../hooks";
import { useFormik } from "formik";
import { IEmailComposeDialog } from "./EmailCompose.types";
import { sendEmail } from "../../../redux/common/commonActions";
import { Button, Grid, SelectChangeEvent } from "@mui/material";
import {
  ControlledCustomSelect,
  CustomCheckBoxWithLabel,
  CustomFormLabel,
  CustomTextField,
} from "../../formsComponents";
import { IMail } from "../../../redux/common/common.types";
import { api } from "../../../api/api";
import { fetchTemplateListAllTempsAsync } from "../../../redux/templates/templateActions";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../redux/initialStoreState";
import { ICreateTemplate } from "../../../redux/templates/templates.types";
import { useAuth } from "../../../contexts/AuthProvider/AuthProvider";
import { FileUpload } from "../../../features/FileUpload/components/FileUpload";
import { getUniqueId } from "../../../helpers";
import { IFileUpload } from "../../../features/FileUpload/components/FileUpload.type";
import { SHARED_EMAILS } from "../../../constants/constants";
import { useRoles } from "../../../security/RolesProvider/RolesProvider";
import { ErrorMessage } from "../../ErrorMessage/ErrorMessage";
import { Editor } from "../../Editor/Editor";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
} from "../../../redux/messages/messagesActions";

const INITIAL_MAIL_PAYLOAD: IMail = {
  from_email: null,
  from_name: null,
  emails: [],
  subject: "",
  body: "",
  templateName: null,
  templateId: null,
  objectVariables: {},
  bcc: [],
  cc: [],
  reply_to: {
    email: "",
    name: "",
  },
};

export const EmailComposeDialog: React.FC<IEmailComposeDialog> = (props) => {
  const {
    toEmail,
    open,
    onClose,
    onComplete,
    relatedModuleId,
    enableAttachments = false,
    attachements = [],
    subject,
    history,
    objectvaraibles,
    includeAttachments,
    body,
    fromclaimEmail,
    AttachmentName,
    module
  } = props;
  console.log("objectvaraibles3", objectvaraibles);
  const { sharedEmails } = useRoles();
  const [loading, setLoading] = React.useState(false);
  const dispatch = useDispatchWrapper();
  const templates = useSelector(
    (storeState: IStoreState) => storeState.templates.list,
  );
  const { user } = useAuth();
  const [attachmentsList, setAttachmentsList] = React.useState<IFileUpload[]>(
    attachements.map((x) => ({ file: null, key: getUniqueId(), path: x })),
  );
  const [includeAttachmentChecked, setIncludeAttachmentChecked] =
    React.useState(false);
  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    setFieldValue,
    setValues,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      ...INITIAL_MAIL_PAYLOAD,
      emails: toEmail
        ? Array.isArray(toEmail)
          ? [...(toEmail as any)]
          : [toEmail]
        : [],
      subject: subject || "",
      reply_to: {
        email: user.email,
        name: user.name,
      },
      body: body || "",
      objectVariables: objectvaraibles
        ? Array.isArray(objectvaraibles)
          ? objectvaraibles
          : objectvaraibles
        : {},
    },

    validate: (values) => {
      const errors: any = {};
      if (!values.from_email) {
        errors.from_email = "From email is required!";
      }
      if (!values.subject && !values.templateId) {
        errors.subject = "Subject is requried!";
      } else if (!values.body) {
        errors.body = "Body is requried!";
      }
      return errors;
    },
    onSubmit: async (values) => {
      setLoading(true);
      const data = { ...values.objectVariables };
      // const keys = Object.keys(data);
      // if (keys.length > 0) {
      //   data[keys[0]] = Array.isArray(objectvaraibles)
      //     ? objectvaraibles
      //     : objectvaraibles;
      // }
      console.log("data obj", data);

      dispatch(
        sendEmail({
          payload: { ...values, history: history, objectVariables: data },
          attachments: attachmentsList,
          onCallback: (isSucess) => {
            if (isSucess) {
              if (onComplete) {
                onComplete();
              } else {
                onClose();
              }
            }
            setLoading(false);
          },
          module,
          AttachmentName,
        }),
      );
    },
  });
  console.log("values", values);
  const handleEmailReplyTo = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setValues({
      ...values,
      reply_to: {
        email: e.target.value,
        name: "",
      },
    });
  };

  // React.useEffect(() => {
  //   if (!fromclaimEmail) return;

  //   const claims = SHARED_EMAILS.find((e) =>
  //     e.label.toLowerCase().includes("claim"),
  //   );

  //   if (claims) {
  //     setValues((v) => ({
  //       ...v,
  //       from_email: claims.value,
  //       from_name: claims.label,
  //     }));
  //   }
  // }, [fromclaimEmail]);

  const handleFromChange = (e: SelectChangeEvent<unknown>) => {
    const value = e.target.value as string;
    const selectedOption = SHARED_EMAILS.find(
      (option) => option.value === value,
    );

    if (selectedOption) {
      setValues({
        ...values,
        from_email: value,
        from_name: selectedOption.label,
      });
    }
  };

  const handleTemplateChange = (e: SelectChangeEvent<unknown>) => {
    const value = e.target.value as string;
    const template = templates.find((x) => x.template_code === value);

    setValues({
      ...values,
      subject: "",
      body: "",
      templateName: null,
      objectVariables: {},
      templateId: value,
    });
  };

  const emailLists = React.useMemo(() => {
    return SHARED_EMAILS;
  }, [sharedEmails]);

  React.useEffect(() => {
    dispatch(fetchTemplateListAllTempsAsync(relatedModuleId));
  }, []);

  React.useEffect(() => {
    const fetchTemplate = async () => {
      try {
        dispatch(saveLoaderProgress());
        const res = await api.get(
          `/templates/get-templates?template_code=${values.templateId}`,
        );
        const list: ICreateTemplate[] = res.data.data;
        if (list.length > 0) {
          const template = list[0];
          // const objectvariables: any = {};
          // if (template.under_variable_data_would_bind) {
          //   objectvariables[template.under_variable_data_would_bind] = {};
          // }

          setValues({
            ...values,
            subject: template.template_subject,
            body: template.body as string,
            objectVariables: Array.isArray(objectvaraibles)
              ? objectvaraibles
              : objectvaraibles,
          });
        }
      } catch (err) {
        console.log(err);
      } finally {
        dispatch(saveLoaderCompleted());
      }
    };
    if (values.templateId) {
      fetchTemplate();
    }
  }, [values.templateId]);

  return (
    <RightPanel
      open={open}
      heading="Send Message as Email"
      subHeading="Connecting Through Email: Delivering Messages to Specified Email"
      onClose={onClose}
      isWrappedWithForm
      onFormSubmit={handleSubmit}
      actionButtons={() => {
        return (
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Button
                variant="contained"
                type="submit"
                disabled={loading}
                fullWidth
              >
                Send
              </Button>
            </Grid>
            <Grid item xs={12} md={4}>
              <Button variant="contained" fullWidth onClick={onClose}>
                Cancel
              </Button>
            </Grid>
          </Grid>
        );
      }}
    >
      <Grid container>
        <Grid item xs={12} md={12}>
          <CustomFormLabel>From</CustomFormLabel>
          <ControlledCustomSelect
            fullWidth
            name="from_email"
            value={values.from_email}
            onChange={handleFromChange}
            placeholder="Select one"
            displayEmpty
            options={emailLists}
            error={errors.from_email ? true : false}
            helperText={errors.from_email}
          ></ControlledCustomSelect>
        </Grid>
        {/* <Grid item xs={12} md={12}>
          <CustomFormLabel>To</CustomFormLabel>

          <CustomTextField
            //disabled={toEmail ? true : false}
            fullWidth
            name={!Array.isArray(toEmail) ? "emails" : "emails[0]"}
            value={
              Array.isArray(toEmail)
                ? values.emails.join(",")
                : values.emails[0]
            }
            onChange={handleChange}
          />
        </Grid> */}
        <Grid item xs={12} md={12}>
          <CustomFormLabel>To</CustomFormLabel>

          <CustomTextField
            fullWidth
            value={(values.emails ?? []).join(",")}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const inputValue = e.target.value;

              const emailArray = inputValue
                .split(",")
                .map((email) => email.trim())
                .filter((email) => email !== "");

              setFieldValue("emails", emailArray);
            }}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <CustomFormLabel>CC</CustomFormLabel>

          <CustomTextField
            fullWidth
            name={"cc[0]"}
            value={values.cc[0]}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <CustomFormLabel>Reply</CustomFormLabel>
          <CustomTextField
            name="reply_to.email"
            fullWidth
            value={values.reply_to ? values.reply_to.email : ""}
            onChange={handleEmailReplyTo}
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <CustomFormLabel>Template</CustomFormLabel>
          <ControlledCustomSelect
            fullWidth
            value={values.templateId}
            name="sub_mobules"
            onChange={handleTemplateChange}
            placeholder="Choose Template"
            displayEmpty
            options={templates.map((item) => {
              return { label: item.template_name, value: item.template_code };
            })}
          ></ControlledCustomSelect>
        </Grid>

        <Grid item xs={12} md={12}>
          <CustomFormLabel>Subject</CustomFormLabel>
          <CustomTextField
            name="subject"
            fullWidth
            value={values.subject}
            onChange={handleChange}
            error={errors.subject ? true : false}
            helperText={errors.subject}
          />
        </Grid>
        {includeAttachments && (
          <Grid item xs={12} md={12}>
            <CustomCheckBoxWithLabel
              label="Include Attachment"
              checked={includeAttachmentChecked}
              onChange={async (e) => {
                const checked = e.target.checked;
                setIncludeAttachmentChecked(checked);
                if (checked && includeAttachments?.onFetch) {
                  try {
                    dispatch(saveLoaderProgress());
                    const result = await includeAttachments.onFetch();
                    setAttachmentsList(
                      result.map((path) => ({
                        file: null,
                        key: getUniqueId(),
                        path,
                      })),
                    );
                  } catch (err) {
                    console.error("Error fetching attachments:", err);
                  } finally {
                    dispatch(saveLoaderCompleted());
                  }
                }
              }}
            />
          </Grid>
        )}
        <Grid item xs={12} md={12}>
          <CustomFormLabel>Message</CustomFormLabel>

          <Editor
            content={values.body}
            onChange={(html) => setFieldValue("body", html)}
          />
          {errors.body && <ErrorMessage value={errors.body} />}
        </Grid>

        {(attachmentsList.length > 0 || enableAttachments) && (
          <Grid item xs={12} md={12}>
            <CustomFormLabel>Attachments</CustomFormLabel>
            <FileUpload
              multiple
              value={attachmentsList}
              disabled={!enableAttachments}
              deleteDisabled
              onMultiChange={enableAttachments ? (values) => {
                setAttachmentsList(values)
              } : undefined}
            />
          </Grid>
        )}
      </Grid>
    </RightPanel>
  );
};
